import isEmpty from 'lodash/isEmpty';
import { useCallback } from 'react';

import { useFormController, Validate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { translationKeys } from './translations';
import { PatientSimpleCreateFormController, PatientSimpleCreateFormFormBean } from './PatientSimpleCreateForm.types';
import { FirstNameField } from './fields/FirstNameField';
import { LastNameField } from './fields/LastNameField';
import { PhoneNumberField } from './fields/PhoneNumberField';

type PatientSimpleCreateFormChildrenRenderProps = Pick<PatientSimpleCreateFormController, 'handleSubmit' | 'formState'>;

type PatientSimpleCreateFormProps = {
   readonly children: (renderProps: PatientSimpleCreateFormChildrenRenderProps) => JSX.Element;
};

export const PatientSimpleCreateForm = (props: PatientSimpleCreateFormProps): JSX.Element => {
   const { register, handleSubmit, formState, trigger, watch } = useFormController<PatientSimpleCreateFormFormBean>({
      phoneNumber: null,
      firstName: null,
      lastName: null,
   });

   const bean = watch();

   const triggerFirstName = useCallback<Validate>(() => {
      trigger('firstName');
      return undefined;
   }, [trigger]);

   const validateAtLeastOneFieldNotEmpty = useCallback<Validate>(() => {
      if (isEmpty(bean.firstName) && isEmpty(bean.lastName) && isEmpty(bean.phoneNumber)) {
         return translationKeys.shouldFillAtLeastOneField;
      }

      return undefined;
   }, [bean.firstName, bean.lastName, bean.phoneNumber]);

   return (
      <>
         <StyledFlex as={'form'} direction={'column'} gap={24} noValidate autoComplete={'off'}>
            <FirstNameField register={register} onValidate={validateAtLeastOneFieldNotEmpty} />
            <LastNameField register={register} onValidate={triggerFirstName} />
            <PhoneNumberField register={register} onValidate={triggerFirstName} />
         </StyledFlex>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </>
   );
};
